import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { FetchResponse } from './types.ts'

const getList = async <T>(
  params: string | undefined
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<T>(
      `/api/dd_panel_patient_profiles/${params}`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const getDetails = async <T>(
  patientProfileId: number
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<T>(
      `/api/dd_panel_patient_profiles/${patientProfileId}`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.detail
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

const createProfile = async <TResponse, TPayload>(
  data: TPayload
): Promise<FetchResponse<TResponse>> => {
  const fetchResponse: FetchResponse<TResponse> = {
    data: null,
    status: 200,
    error: null
  }

  try {
    const response = await httpClient.post<TResponse>(
      '/api/dd_panel_patient_profiles/',
      data
    )

    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.detail
      fetchResponse.status = error.response?.status as number
    }
  }

  return fetchResponse
}

const editProfile = async <TResponse, TPayload>(
  patientProfileId: number,
  data: TPayload
): Promise<FetchResponse<TResponse>> => {
  const fetchResponse: FetchResponse<TResponse> = {
    data: null,
    status: 200,
    error: null
  }
  const response = await httpClient.put<TResponse>(
    `/api/dd_panel_patient_profiles/${patientProfileId}/`,
    data
  )

  fetchResponse.data = response.data
  fetchResponse.status = response.status

  return fetchResponse
}

const deleteProfile = async <TResponse>(
  patientProfileId: number,
): Promise<FetchResponse<TResponse>> => {
  const fetchResponse: FetchResponse<TResponse> = {
    data: null,
    status: 200,
    error: null
  }
  const response = await httpClient.delete<TResponse>(
    `/api/dd_panel_patient_profiles/${patientProfileId}/`
  )

  fetchResponse.data = response.data
  fetchResponse.status = response.status

  return fetchResponse
}

const synchronizeBodyMeasurements = async <T>(
  patientProfileId: number
): Promise<FetchResponse<T>> => {
  const fetchResponse: FetchResponse<T> = {
    data: null,
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post<T>(
      `/api/dd_panel_patient_profiles/${patientProfileId}/synchronize_body_measurements_with_pd3/`
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.detail
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse
}

export const patientProfilesApi = {
  getList,
  getDetails,
  createProfile,
  editProfile,
  deleteProfile,
  synchronizeBodyMeasurements
}
